export type GenericObject = Record<string, any>
